export class Microsoft365SharePointSiteSelectedItemsOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "items",
            "baseName": "items",
            "type": "Array<SaasRestoreItem>",
            "format": ""
        },
        {
            "name": "restoreMode",
            "baseName": "restoreMode",
            "type": "SaasRestoreMode",
            "format": ""
        },
        {
            "name": "folderName",
            "baseName": "folderName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return Microsoft365SharePointSiteSelectedItemsOptions.attributeTypeMap;
    }
    constructor() {
    }
}
